
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MessageItemProps } from ".";
import { loading, update } from "store/message";
import { AppMessage } from "components";

interface ApiMessageUpdateInputProps extends MessageItemProps {
}

type ApiMessageUpdateOutputProps = OutputBaseProps<{ item: MessageItemProps; }, ApiMessageUpdateInputProps>

export const apiMessageUpdate = async (data: ApiMessageUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiMessageUpdateOutputProps>("/api/message/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};